import React from 'react';
import { ButtonsWrapper, Wrapper } from '../refundDetails/refundDetails.styles';
import Input from '@/common/components/Input';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';
import { Title } from '../../Refunds.styles';

const Confirmation = ({ hook }) => {
	return (
		<Wrapper>
            <Title>Confirmation</Title>
			<Input
				inputRef={hook.commentRef}
				placeholder='Enter comment'
				name='comment'
				color={Colors.darkBlue}
				width={110}
			/>
            <ButtonsWrapper>
                <ActionButton
                    color={Colors.green}
                    onClick={() => hook.setConfirmationPopup(false)}
                    style={{ width: '100px' }}
                >
                    Cancel
                </ActionButton>
                <ActionButton
                    color={Colors.red}
                    onClick={hook.handleDeclineRefund}
                    style={{ width: '150px' }}
                >
                    Confirm decline
                </ActionButton>
            </ButtonsWrapper>
		</Wrapper>
	);
};

export default Confirmation;